import React from 'react';
import { ArrowUpRight, TrendingUp } from 'lucide-react';
import { CaseStudy } from '../types';

export const Cases: React.FC = () => {
  const cases: CaseStudy[] = [
    {
      id: 1,
      client: "Burger Brothers",
      industry: "Gastronomie",
      title: "VIRALER LAUNCH",
      description: "Aggressive TikTok-Kampagne. Laden am Eröffnungstag komplett ausverkauft.",
      stats: ["+45% Umsatz", "2.1M Views"],
      image: "https://images.unsplash.com/photo-1550547660-d9450f859349?auto=format&fit=crop&q=80&w=800"
    },
    {
      id: 2,
      client: "ImmoVision",
      industry: "Real Estate",
      title: "MAKLER LEAD-GEN",
      description: "Redesign der Landingpage und Integration von Qualifizierungs-Funnels.",
      stats: ["+120 Leads", "3.4% Conv."],
      image: "https://images.unsplash.com/photo-1605146769289-440113cc3d00?auto=format&fit=crop&q=80&w=800"
    },
    {
      id: 3,
      client: "Iron Gym",
      industry: "Fitness",
      title: "MEMBER GROWTH",
      description: "Authentische 'Behind the Scenes' Inhalte für lokale Brand Awareness.",
      stats: ["+80 Member", "Zero Ads"],
      image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&q=80&w=800"
    }
  ];

  return (
    <section id="cases" className="py-24 bg-[#111111] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
           <div>
              <h2 className="text-5xl md:text-7xl font-black uppercase tracking-tighter mb-4 text-white animate-fade-in-up opacity-0">
                Success <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-500 to-white">Stories</span>
              </h2>
           </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
           {cases.map((item, index) => (
             <div key={item.id} className="group relative bg-[#1a1a1a] rounded-[2rem] overflow-hidden hover:-translate-y-3 transition-all duration-700 ease-apple border border-white/5 hover:border-brand-orange/50 flex flex-col h-full animate-fade-in-up opacity-0" style={{ animationDelay: `${0.2 + (index * 0.2)}s` }}>
                {/* Image */}
                <div className="h-64 w-full overflow-hidden relative shrink-0">
                   <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent z-10"></div>
                   <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000 ease-apple opacity-80 group-hover:opacity-100" />
                   <div className="absolute top-4 left-4 z-20 bg-brand-orange text-white text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest shadow-lg">
                      {item.industry}
                   </div>
                </div>

                {/* Content */}
                <div className="p-8 relative z-20 -mt-10 flex flex-col flex-grow">
                   <h3 className="text-2xl font-black mb-3 group-hover:text-brand-orange transition-colors duration-500 ease-apple flex items-center justify-between uppercase min-h-[4rem] leading-tight">
                      {item.title}
                      <ArrowUpRight className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500 ease-apple text-brand-orange flex-shrink-0 ml-2" />
                   </h3>
                   
                   <p className="text-gray-400 text-sm mb-6 leading-relaxed flex-grow">
                      {item.description}
                   </p>
                   
                   <div className="flex flex-wrap gap-2 mt-auto">
                      {item.stats.map((stat, i) => (
                        <div key={i} className="bg-white/5 border border-white/10 text-white text-xs font-bold px-3 py-2 rounded-lg flex items-center gap-2">
                           <TrendingUp size={12} className="text-brand-orange" />
                           {stat}
                        </div>
                      ))}
                   </div>
                </div>
             </div>
           ))}
        </div>
      </div>
    </section>
  );
};